module.exports = __webpack_public_path__ + "img/picon2.554a9539.png";